"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSignEmploymentContractDto = instanceOfSignEmploymentContractDto;
exports.SignEmploymentContractDtoFromJSON = SignEmploymentContractDtoFromJSON;
exports.SignEmploymentContractDtoFromJSONTyped = SignEmploymentContractDtoFromJSONTyped;
exports.SignEmploymentContractDtoToJSON = SignEmploymentContractDtoToJSON;
exports.SignEmploymentContractDtoToJSONTyped = SignEmploymentContractDtoToJSONTyped;
/**
 * Check if a given object implements the SignEmploymentContractDto interface.
 */
function instanceOfSignEmploymentContractDto(value) {
    if (!('signature' in value) || value['signature'] === undefined)
        return false;
    return true;
}
function SignEmploymentContractDtoFromJSON(json) {
    return SignEmploymentContractDtoFromJSONTyped(json, false);
}
function SignEmploymentContractDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'signature': json['signature'],
    };
}
function SignEmploymentContractDtoToJSON(json) {
    return SignEmploymentContractDtoToJSONTyped(json, false);
}
function SignEmploymentContractDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'signature': value['signature'],
    };
}
//# sourceMappingURL=SignEmploymentContractDto.js.map